// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { SiteProfiles_abstract } from './../abstract/SagaBase/SiteProfiles_abstract';
export class SiteProfiles extends SiteProfiles_abstract {}
